









import Vue, { PropType } from 'vue';
import {
  CvSectionProfile,
  CvSectionProfileSexEnum,
  UpdateCvSectionProfileRequestSexEnum,
} from '@/../gen';
import SectionForm, {
  FormDataInterface,
} from '@/containers/cv-section-profile/form.vue';
import * as CvSectionProfileStore from '@/containers/cv-section-profile/store';
import { DATE_SEPARATOR_IN_FORM } from '@/utils/constants';
import { i18n, i18nHints } from '@/plugins/i18n';

import { splitDate } from '@/utils/date';

export default Vue.extend({
  components: {
    SectionForm,
  },
  props: {
    section: {
      type: Object as PropType<CvSectionProfile>,
      required: true,
    },
  },
  methods: {
    async onSubmit({
      profile_image,
      remove_profile_image,
      full_name,
      birthday,
      sex,
      email,
      phone_number,
      location,
      headline,
      website_url,
    }: FormDataInterface) {
      const { cv_id } = this.section;
      const [birthday_year, birthday_month, birthday_day] = splitDate(
        birthday,
        DATE_SEPARATOR_IN_FORM
      );
      // FIXME Reusable SexEnum
      let sexConverted = null;
      if (sex === CvSectionProfileSexEnum.NotApplicable)
        sexConverted = UpdateCvSectionProfileRequestSexEnum.NotApplicable;
      if (sex === CvSectionProfileSexEnum.Female)
        sexConverted = UpdateCvSectionProfileRequestSexEnum.Female;
      if (sex === CvSectionProfileSexEnum.Male)
        sexConverted = UpdateCvSectionProfileRequestSexEnum.Male;
      if (sex === CvSectionProfileSexEnum.NotKnown)
        sexConverted = UpdateCvSectionProfileRequestSexEnum.NotKnown;

      await this.$store.dispatch(
        CvSectionProfileStore.UpdateCvSectionProfile.namespaced({
          params: {
            cv_id,
          },
          body: {
            // FIXME It's complicated...
            profile_image:
              (profile_image as any) instanceof File
                ? (profile_image as any)
                : undefined,
            remove_profile_image,
            full_name: full_name || '',
            birthday_year: Number(birthday_year) || null,
            birthday_month: Number(birthday_month) || null,
            birthday_day: Number(birthday_day) || null,
            sex: sexConverted,
            email: email || '',
            phone_number: phone_number || '',
            location: location || '',
            headline: headline || '',
            website_url: website_url || '',
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
  },
});
